import { clearCacheOnUserChange } from '@smartsash/auth';
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@smartsash/ui/tokens.css';
// The icomoon glyph font backing `<Icon>`; without it every glyph renders as a blank box.
// Admin used to carry its own byte-identical copy of this font (HS-1170 deleted it).
import '@smartsash/ui/icons.css';
import '@/i18n';
// Last so admin's reset wins over the package's element defaults.
import '@/index.css';

import { bootstrapApiClient } from '@/apiClient';
import { bootstrapChunkReload } from '@/chunkReload';
import { bootstrapTheme } from '@/preferences/theme';
import { queryClient } from '@/queryClient';
import { bootstrapServerOpsNotifications } from '@/serverOpsNotifications';
import { authClient } from '@/services/auth/authClient';
import App from '@/ui/App';

// Registered before the router can request its first lazy route, so no preload failure is
// missed while the app is still coming up.
bootstrapChunkReload();
bootstrapApiClient();
bootstrapServerOpsNotifications();
// Before the first sign-in: the next user in this tab must never be shown the previous one's data.
clearCacheOnUserChange(authClient, queryClient);
// Before `createRoot`, not in an effect: the attribute has to be on <html> for the very first
// paint, or a dark-theme visitor gets a light flash on every load (HS-1533).
bootstrapTheme();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('index.html is missing its #root mount point.');

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
